// © Microsoft Corporation. All rights reserved.
import MultiLoginPage from "./multi-login-page/MultiLoginPage";
import { NotificationTray } from "./common/notification/NotificationTray";
import OnboardingPage from "./onboarding-page/OnboardingPage";
import OnboardingThirdPartyPage from "./onboarding-page/OnboardingThirdPartyPage";
import ReactionBreakdown from "./reaction-breakdown/ReactionBreakdown";

import {
    SocialExperienceRenderErrorMultilineLogin,
    SocialExperienceRenderErrorNotificationTray,
    SocialExperienceRenderErrorOnbardingThirdParty,
    SocialExperienceRenderErrorOnboarding,
    SocialExperienceRenderErrorReactionBreakdown,
    SocialExperienceRenderErrorUnknownComponent
} from "@msnews/diagnostics";

export const RenderErrors = {
    [MultiLoginPage.name]: SocialExperienceRenderErrorMultilineLogin,
    [NotificationTray.name]: SocialExperienceRenderErrorNotificationTray,
    [OnboardingThirdPartyPage.name]: SocialExperienceRenderErrorOnbardingThirdParty,
    [OnboardingPage.name]: SocialExperienceRenderErrorOnboarding,
    [ReactionBreakdown.name]: SocialExperienceRenderErrorReactionBreakdown,
    UnknownComponent: SocialExperienceRenderErrorUnknownComponent
};